module.exports = __webpack_public_path__ + "img/macdonald_realty_two_colour_logo.ccc29296.svg";